import { courseAPI } from '@/api'
import {
  LearningDynamicsCourse,
  SetAccessLevelPayload,
} from './types'

export const getStudentLearningDynamics = async (
  studentId: number,
): Promise<LearningDynamicsCourse[]> => {
  const response = await courseAPI.getLearningDynamicsV2(studentId)
  const data = response?.data?.data ?? response?.data

  return Array.isArray(data) ? data : []
}

export const setStudentAccessLevel = async (
  payload: SetAccessLevelPayload,
): Promise<void> => {
  const response = await courseAPI.setAccessLevel(payload)

  if (response?.data?.status !== 'success') {
    const error = new Error(response?.data?.error || 'Ошибка изменения доступа')
    Object.assign(error, { response })
    throw error
  }
}

export const resetCourseProgress = async (
  studentId: number,
  courseId: number,
): Promise<boolean> => {
  const response = await courseAPI.resetCourseLearningDynamic({
    userId: studentId,
    courseId,
  })

  return response?.data?.status === 'success'
}

export const resetLessonProgress = async (
  studentId: number,
  courseId: number,
  lessonId: number,
): Promise<boolean> => {
  const response = await courseAPI.resetTopicLearningDynamic({
    userId: studentId,
    courseId,
    topicId: lessonId,
  })

  return response?.data?.status === 'success'
}

export const resetBlockProgress = async (
  studentId: number,
  blockId: number,
): Promise<boolean> => {
  const data = new FormData()
  data.append('user_id', String(studentId))
  data.append('block_id', String(blockId))

  const response = await courseAPI.resetBlockProgressForUser(data)
  return response?.data?.status === 'success'
}

export const updateLessonProgress = async (
  studentId: number,
  lessonId: number,
  progress: number,
): Promise<boolean> => {
  const data = new FormData()
  data.append('user_id', String(studentId))
  data.append('lesson_id', String(lessonId))
  data.append('progress', String(progress))

  const response = await courseAPI.changeLessonUserProgress(data)
  return response?.data?.status === 'success'
}
